import React from 'react';
import './Banner.css';

const Banner = () => {
  return (
    <section className="banner">
      <div className="banner-container">
        <img src="/kahvebanner.png" alt="Bulut Ambalaj Banner" className="banner-image" />
      </div>
    </section>
  );
};

export default Banner;
